<script>
  import axios from 'axios'
  import carousel from '@/components/cover-flow-carousel.vue'
  export default {
    components: {
      carousel
    },
    props: {
      // newMaterials: {
      //   type: Object,
      //   required: true,
      // },
    },
    data: () => ({
      newMaterialLists: [],
      activeMedia: {},
      isLoading: true
    }),
    methods: {
      setActiveItem(item) {
        // console.log(item)
        this.$set(this.activeMedia, item.category, item.item)
      }
    },
    created() {
      //SET LOADING
      //FETCH NEW MATERIALS
      //SET "VIEWING" ITEMS TO OBJECT TO FIRST
      // this.$axios({
      //     url: 'https://eipl.org/api/index.php/welcome/programs_get',
      //     method: 'get',
      //     mode: 'no-cors'
      //    }).then(data => {
      //     console.log(data)
      //     this.contentloading = false
      //   })
      const url = 'https://old.eipl.org/api/index.php/org/new_materials/sample'
      // const url = 'https://eipl.org/api/index.php/org/new_materials_get/sample'
      const withCredentials = true
      axios(url, {
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        mode: 'no-cors',
        method: 'GET',
        url,
        withCredentials
      }).then(response => {
        // console.log(response)
        if (response && response.data?.length > 0) {
          this.newMaterialLists = response.data
          this.newMaterialLists.forEach(list => {
            this.setActiveItem({
              category: list.category,
              item: list.items[0]
            })
          })
        }
        this.isLoading = false
        // this.programsUpcoming = response
        // this.contentLoading = false
      })
    }
  }
</script>
<template>
  <v-card flat rounded class="card">
    <v-card-title class="card-title transparent text-h4 font-weight-bold secondary--text">
      <router-link :to="{ name: 'new-material' }" class="text-h4 font-weight-bold secondary--text text-decoration-none">LATEST ARRIVALS </router-link>
    </v-card-title>
    <v-card-text class="d-flex align-center justify-center" style="height: 100%">
      <v-card color="transparent" flat v-if="isLoading || newMaterialLists.length < 1">
        <v-card-text class="d-flex flex-column align-center justify-center">
          <v-progress-circular indeterminate color="primary" v-if="isLoading" class="mt-4"></v-progress-circular>
          <p class="text-h6 primary--text">Getting latest arrivals...</p>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
      <v-row v-else width="100%" class="card-text d-flex align-center justify-center flex-wrap">
        <v-col
          v-for="list in newMaterialLists"
          :key="list.category"
          cols="12"
          sm="6"
          lg="4"
          align-self="stretch"
          color="transparent"
          class="carousel-container d-flex flex-column align-center justify-center mt-4 px-0 px-sm-2"
          :class="`ma-${$vuetify.breakpoint.mdAndDown ? '0' : 'auto'}`"
        >
          <v-sheet color="transparent" height="300px" width="100%" class="d-flex align-center justify-center">
            <carousel :itemList="list" @active-item="setActiveItem"></carousel>
          </v-sheet>
          <!-- <v-sheet
            color="transparent"
            height="80"
            :max-width="$vuetify.breakpoint.xs ? 240 : 300"
            width="100%"
            class="d-flex flex-column align-start justify-start secondary--text py-4"
          >
            <a
              class="item-active-text text-h6 text-truncate ma-0"
              :href="activeMedia[list.category].catalogUrl"
              target="_blank"
              rel="noreferrer"
              :title="activeMedia[list.category].title || ''"
              >{{ activeMedia[list.category].title || '' }}</a
            >
            <p class="item-active-text text-subtitle-1 text-truncate ma-0">
              <i>{{ activeMedia[list.category].authors[0] || '' }}</i>
            </p>
          </v-sheet> -->
          <v-sheet color="transparent" :max-width="$vuetify.breakpoint.xs ? 240 : 300" width="100%">
            <v-btn block color="primary" large rounded :to="`/new-material/${list.slug}`" class="action-btn">
              <v-icon color="secondary" class="mr-2">mdi-format-list-bulleted</v-icon>
              <span clss="secondary--text font-weight-bold">{{ list.category }}</span>
            </v-btn>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .card {
    background-color: #dcf4e8;
    background-image: url('https://media.eipl.org/site/images/pages/home/parachute-delivery.jpg');
    object-fit: cover;
    background-position: top center;
    /* background-repeat: repeat; */
    background-size: 100%;
    min-height: 600px;
  }
  .card-text {
    background-color: #00006660;
    border-radius: 5px;
  }
  .carousel-container {
    /* background-color: #00006660; */
    height: 440px;
    width: min(100%, 400px);
    /* min-width: 400px; */
    border-radius: 50%;
  }
  .item-active-text {
    line-height: 1.35rem;
    width: 350px;
    width: min(100%, 350px);
  }

  a.item-active-text {
    /* text-decoration: none; */
    color: inherit;
  }

  .action-btn {
    /* width: 150px; */
  }
</style>
